import React from 'react';
function Gift({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 12v9H5v-9M21 8H3v4h18V8zM12 21V8M12 8H8.143c-.568 0-1.114-.263-1.515-.732C6.226 6.798 6 6.163 6 5.5s.226-1.299.628-1.768C7.029 3.263 7.575 3 8.143 3 11.143 3 12 8 12 8zM12 8h3.857c.569 0 1.114-.263 1.515-.732.402-.47.628-1.105.628-1.768s-.226-1.299-.628-1.768C16.971 3.263 16.425 3 15.857 3 12.857 3 12 8 12 8z"
      />
    </svg>
  );
}

export default Gift;
